<template>
    <div class="widget-calendar">
        <div class="card border-0 h-100">
            <div class="card-body">
                <h3 class="text-left mb-4 border-bottom p-2">{{ heading }}</h3>
                <div class="d-flex flex-column">
                    <div v-if="data1.name" class="row align-items-center py-2 border-bottom text-center text-md-start">
                        <div class="col-12 col-md-4">
                            <h2 class="display-2 font-weight-bold mb-0">{{ data1.value }}</h2>
                        </div>
                        <div class="col-1 d-md-block d-none">
                            <div class="vertical-line bg-warning"></div>
                        </div>
                        <div class="col-12 d-block d-md-none">
                            <div class="horizontal-line bg-warning mt-2 mx-auto"></div>
                        </div>
                        <div class="col-12 col-md-2">
                            <span class="d-md-none badge bg-secondary px-3 py-2 my-2 text-dark">{{ data1.name }}</span>
                            <small class="text-muted d-none d-md-inline">{{ data1.name }}</small>
                        </div>
                        <div class="col-1 d-md-block d-none">
                            <div class="vertical-line bg-warning"></div>
                        </div>
                        <div class="col-12 col-md-4">
                            <small class="text-muted">{{ data1.description }}</small>
                        </div>
                    </div>
                    <div v-if="data2.name" class="row align-items-center py-2 border-bottom text-center text-md-start">
                        <div class="col-12 col-md-4">
                            <h2 class="display-2 font-weight-bold mb-0">{{ data2.value }}</h2>
                        </div>
                        <div class="col-1 d-md-block d-none">
                            <div class="vertical-line bg-info"></div>
                        </div>
                        <div class="col-12 d-block d-md-none">
                            <div class="horizontal-line bg-info mt-2 mx-auto"></div>
                        </div>
                        <div class="col-12 col-md-2">
                            <span class="d-md-none badge bg-success px-3 py-2 my-2 text-dark">{{ data2.name }}</span>
                            <small class="text-muted d-none d-md-inline">{{ data2.name }}</small>
                        </div>
                        <div class="col-1 d-md-block d-none">
                            <div class="vertical-line bg-info "></div>
                        </div>
                        <div class="col-12 col-md-4">
                            <small class="text-muted">{{ data2.description }}</small>
                        </div>
                    </div>
                    <div v-if="data3.name" class="row align-items-center py-2 border-bottom text-center text-md-start">
                        <div class="col-12 col-md-4">
                            <h2 class="display-2 font-weight-bold mb-0">{{ data3.value }}</h2>
                        </div>
                        <div class="col-1 d-md-block d-none">
                            <div class="vertical-line bg-success"></div>
                        </div>
                        <div class="col-12 d-block d-md-none">
                            <div class="horizontal-line bg-success mt-2 mx-auto"></div>
                        </div>
                        <div class="col-12 col-md-2">
                            <span class="d-md-none badge bg-warning px-3 py-2 my-2 text-dark">{{ data3.name }}</span>
                            <small class="text-muted d-none d-md-inline">{{ data3.name }}</small>
                        </div>
                        <div class="col-1 d-md-block d-none">
                            <div class="vertical-line bg-success"></div>
                        </div>
                        <div class="col-12 col-md-4">
                            <small class="text-muted">{{ data3.description }}</small>
                        </div>
                    </div>
                    <div v-if="data4.name" class="row align-items-center py-2 text-center text-md-start">
                        <div class="col-12 col-md-4">
                            <h2 class="display-2 font-weight-bold mb-0">{{ data4.value }}</h2>
                        </div>
                        <div class="col-1 d-md-block d-none">
                            <div class="vertical-line bg-danger"></div>
                        </div>
                        <div class="col-12 d-block d-md-none">
                            <div class="horizontal-line bg-danger mt-2 mt-2 mx-auto"></div>
                        </div>
                        <div class="col-12 col-md-2">
                            <span class="d-md-none badge bg-gray px-3 py-2 my-2 text-dark">{{ data4.name }}</span>
                            <small class="text-muted d-none d-md-inline">{{ data4.name }}</small>
                        </div>
                        <div class="col-1 d-md-block d-none">
                            <div class="vertical-line bg-danger"></div>
                        </div>
                        <div class="col-12 col-md-4">
                            <small class="text-muted">{{ data4.description }}</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "dashboardCard",
    components: {
    },
    props: {
        heading: { type: String, default: "" },
        data1: { type: Object, default: {} },
        data2: { type: Object, default: {} },
        data3: { type: Object, default: {} },
        data4: { type: Object, default: {} },
    },
};
</script>
